import * as ApiModels from '@typings/api-models';
import QuestionnaireDetails from '@/components/Questionnaire/QuestionnaireDetails';
import NoFormResponse from './NoFormResponse';

type Props = {
  onComplete: () => void;
  onReload: () => void;
  setFormVersion: (version: number | null) => void;
  shouldForceComplete: boolean;
  formRequest: Pick<ApiModels.FormRequest,
    | 'id'
    | 'status'
    | 'response'
    | 'hasEditPermission'
    | 'hasViewPermission'
    | 'url'
    | 'formReferenceId'
    | 'userWorkflowId'
  > & {
    template: Pick<ApiModels.FormRequestTemplate, 'id' | 'name' | 'provider' | 'providerLocator'>;
  };
};

const NoodleQuestionnaireFormDetails: React.FC<Props> = ({ setFormVersion, formRequest, onComplete, onReload, shouldForceComplete }) => {

  if (formRequest.hasEditPermission && formRequest.status !== ApiModels.FormStatus.COMPLETED) {
    return (
      <QuestionnaireDetails
        setFormVersion={setFormVersion}
        id={formRequest.formReferenceId}
        onComplete={onComplete}
        onReload={onReload}
        userWorkflowId={formRequest.userWorkflowId}
        shouldForceComplete={shouldForceComplete}
        isCompleted={false}
      />
    );
  }

  if (formRequest.hasViewPermission) {
    return (
      <QuestionnaireDetails
        setFormVersion={setFormVersion}
        id={formRequest.formReferenceId}
        onComplete={onComplete}
        onReload={onReload}
        userWorkflowId={formRequest.userWorkflowId}
        isCompleted={true}
      />
    );
  }

  return (
    <NoFormResponse />
  );
};

export default NoodleQuestionnaireFormDetails;
